import React from 'react';

import { useDetailsPanelPortalContextValue } from '../../../../context';
import { useIsVisibleOnDetailsPanel } from './useIsVisibleOnDetailsPanel';
import { VariationDetails } from './VariationDetails';

export const Container = ({ variation, ...restProps }) => {
  const refPortalDetailsPanel = useDetailsPanelPortalContextValue();
  const visibleOnDetailsPanel = useIsVisibleOnDetailsPanel(variation.instanceId);

  if (!refPortalDetailsPanel?.current || !visibleOnDetailsPanel) {
    return null;
  }

  return (
    <VariationDetails
      variation={variation}
      portalElement={refPortalDetailsPanel.current}
      {...restProps}
    />
  );
};
